import { useState } from "react";
import { FolderContentsResponse } from "@repo/api/folder";
import { IconChevronDown } from "@tabler/icons-react";
import { cn } from "@/lib/utils";
import FolderItem from "./FolderItem";

const FOLDER_PREVIEW_LIMIT = 12;

type Props = {
  teamExternalId: string;
  contents: FolderContentsResponse;
};

export default function FoldersSection({ teamExternalId, contents }: Props) {
  const [foldersExpanded, setFoldersExpanded] = useState(false);
  const hasFolders = contents.folders.length > 0;

  if (!hasFolders) {
    return null;
  }

  const hasHiddenFolders = contents.folders.length > FOLDER_PREVIEW_LIMIT;
  const visibleFolders =
    hasHiddenFolders && !foldersExpanded
      ? contents.folders.slice(0, FOLDER_PREVIEW_LIMIT)
      : contents.folders;

  return (
    <div>
      <h2 className="mb-4 text-sm font-semibold text-text-secondary">
        Folders
      </h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {visibleFolders.map((folder) => (
          <FolderItem
            key={folder.externalId}
            folder={folder}
            teamExternalId={teamExternalId}
            folderDepth={contents.breadcrumb.length + 1}
          />
        ))}
      </div>
      {hasHiddenFolders && (
        <button
          type="button"
          onClick={() => setFoldersExpanded((expanded) => !expanded)}
          className="mt-4 -ml-1.5 flex cursor-pointer items-center gap-1 rounded-sm px-1.5 py-1 text-sm font-medium text-text-secondary transition-colors hover:bg-grey-100 hover:text-text-primary"
        >
          <IconChevronDown
            size={16}
            className={cn(
              "shrink-0 transition-transform",
              foldersExpanded && "rotate-180",
            )}
          />
          {foldersExpanded ? "Show less" : `Show more folders`}
        </button>
      )}
    </div>
  );
}
